const ActionType = {
  UPDATE_TAB: 'UPDATE_TAB',
  DELETE_TAB: 'DELETE_TAB'
};

const ModerationTabState = (state, action) => {
  switch (action.type) {
    case ActionType.UPDATE_TAB:
      return [...action.data];

    case ActionType.DELETE_TAB:
      return state.filter((comment) => comment.name !== action.name);

    default:
      return state;
  }
};

module.exports = ModerationTabState;
